class INTENT.utils.Helper

  ###
  Проходит по цилку и приводит все цифры к типу number
  ###
  @to_int_object: (source) ->
    new_stack = []
    for ex_key, ex_value of source
      if parseInt ex_value
        ex_value = parseInt ex_value
      new_stack.push ex_value
    return new_stack

  @ucfirst: (source) ->
    return source.charAt(0).toLocaleUpperCase() + source.substr(1).toLocaleLowerCase()